// Import
import React from "react"
import { Plus } from "react-feather"
import { Substract } from "@icons"

export const Collapse = ({ data, handleTitleClick, selectedIndex }) => {
  return (
    <div className="collapse">
      {data.map((elem, index) => {
        return (
          <div
            key={index}
            className={`collapse-item ${
              selectedIndex === index ? "active" : ""
            }`}
          >
            <div className="collapse-item__left">
              <button onClick={() => handleTitleClick(index)}>
                <span className={`${selectedIndex === index ? "active" : ""}`}>
                  {selectedIndex === index ? (
                    <Substract color="white" />
                  ) : (
                    <Plus color="white" />
                  )}
                </span>
              </button>
            </div>
            <div className="collapse-item__right">
              <button
                onClick={() => handleTitleClick(index)}
              >
                {elem.title}
              </button>
              <p>{elem.shortDescription.shortDescription}</p>
            </div>
          </div>
        )
      })}
    </div>
  )
}
